import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TechCommunitiesModalComponent } from 'src/app/component/tech-communities-modal/tech-communities-modal.component';

@Component({
  selector: 'app-tech-community',
  templateUrl: './tech-community.component.html',
  standalone: false,
  styleUrl: './tech-community.component.scss'
})
export class TechCommunityComponent {
  public simpleDialog!: MatDialogRef<TechCommunitiesModalComponent>;
  public dialogDataConfig: any = {};
  public access: boolean = true;

  constructor(private dialogModel: MatDialog, private router: Router) { }


  ngOnInit() {
    this.dialogDataConfig = {
      title: 'MCT Lounge',
      accessto: "tech communities"
    }
    // disableClose: true
    this.simpleDialog = this.dialogModel.open(
      TechCommunitiesModalComponent, { data: this.dialogDataConfig },
    );
  }
}
